import BottomImage0 from "./assets/images/BottomImage0.jpg";
import BottomImage1 from "./assets/images/BottomImage1.jpg";
import BottomImage2 from "./assets/images/BottomImage2.jpg";
import BottomImage3 from "./assets/images/BottomImage3.jpg";
import BottomImage4 from "./assets/images/BottomImage4.jpg";
import BottomImage5 from "./assets/images/BottomImage5.jpg";
import BottomImage6 from "./assets/images/BottomImage6.jpg";
import BottomImage7 from "./assets/images/BottomImage7.jpg";
import ImageCarousel from "./ImageCarousel";

const images = [
  BottomImage0,
  BottomImage1,
  BottomImage2,
  BottomImage3,
  BottomImage4,
  BottomImage5,
  BottomImage6,
  BottomImage7,
];

export default function BottomImageCarousel() {
  return <ImageCarousel images={images} label="Gym gallery 2" />;
}
